import { Article } from "./articles.model";
import { Commercial } from "./commercials.model";
import { Customer } from "./customers.model";
import { Locality } from "./localities.model";
import { Project } from "./projects.model";
import { Site } from "./sites.model";

export class Sale {

    id: number;
    project: Project;
    customer: Customer;
    commercial: Commercial;
    site: Site;
    articles: Article[];
    createAt: Date;
    locality: Locality;

    constructor() {
        this.project = new Project();
        this.customer = new Customer();
        this.commercial = new Commercial();
        this.site = new Site();
        this.locality = new Locality();
    }
}

export class SaleForm {

    id: number;
    project: number;
    customer: number;
    commercial: number;
    site: number;
    articles: number[];
    createAt: Date;
    locality: Locality;

    constructor() { }
}